module.exports = __webpack_public_path__ + "img/oca.22c11952.webp";